// Closure para hacer debounce en una función
export function debouncerFn<T>(miliseconds: number, callback: (...args: T[]) => void) {
  let timer: number | null = null;

  return (...args: T[]) => {
    if (timer !== null)
      clearTimeout(timer);

    timer = setTimeout(() => {
      timer = null;
      callback(...args);
    }, miliseconds);
  };
};
